require.register("modules/m0x/a05/page-54/page-54", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_54 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_54;

  
});

